module.exports = __webpack_public_path__ + "static/media/2.5ba19a8e.png";